// Полоска загрузки lazy-чанков поверх текущего экрана (nprogress-паттерн).
// Пока чанк грузится, старый экран остаётся на месте (см. RouteTransitionOutlet),
// а сверху ползёт прогресс слева направо; по готовности — рывок до 100% и fade.

import styles from '@web/components/route-progress/styles.module.css'
import { chunkLoadStore } from '@web/libs/chunk-load-store'
import { useEffect, useRef, useState, useSyncExternalStore } from 'react'

type Phase = 'idle' | 'loading' | 'done'

const DONE_RESET_MS = 500

export function RouteProgressBar() {
  const activeCount = useSyncExternalStore(chunkLoadStore.subscribe, chunkLoadStore.getSnapshot)
  const [phase, setPhase] = useState<Phase>('idle')
  const rafRef = useRef(0)

  useEffect(() => {
    if (activeCount > 0) {
      // Через rAF, чтобы браузер успел закоммитить width: 0 и transition стартовал с нуля.
      cancelAnimationFrame(rafRef.current)
      rafRef.current = requestAnimationFrame(() => setPhase('loading'))
      return () => cancelAnimationFrame(rafRef.current)
    }

    setPhase((prev) => (prev === 'loading' ? 'done' : prev))
    const timer = setTimeout(() => setPhase('idle'), DONE_RESET_MS)

    return () => clearTimeout(timer)
  }, [activeCount])

  const phaseToClass: Record<Phase, string> = { idle: '', loading: styles.loading, done: styles.done }
  const phaseClass = phaseToClass[phase]

  return (
    <div className={styles.track} aria-hidden>
      <div className={`${styles.bar} ${phaseClass}`} />
    </div>
  )
}
